<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="交易记录"></pageTitle>

    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @sortChange="sortChange"
    >
      <template v-slot:form_sn="row">
        <el-link type="primary" @click="purchaseOrder(row.row)">{{
          row.row.form_sn
        }}</el-link>
      </template>
      <template v-slot:operation="row">
        <div>
          <template>
            <div class="button button_modify" @click="preview(row.row)">
              <i class="iconfont icon-yulanmoban"></i> 查看
            </div>
          </template>
        </div>
      </template>
      <template v-slot:order_type="row">
        <div style="display: flex; align-items: center">
          <div v-if="row.row.order_type == 1" class="warn">采购</div>
          <div v-else class="safe">销售</div>
        </div>
      </template>

      <template v-slot:customer_name="row">
        <div style="display: flex; align-items: center">
          <div v-if="row.row.nick_name == ''">
            {{ row.row.customer_name }}
          </div>
          <div v-else>{{ row.row.customer_name }}({{ row.row.nick_name }})</div>
        </div>
      </template>

      <template v-slot:last_money="row">
        <div style="display: flex; align-items: center">
          <div v-if="row.row.last_money >= row.row.total_money1" class="warn">
            未付款
          </div>
          <div v-else-if="row.row.last_money > 0" class="dangerous">
            部分付款
          </div>
          <div v-else class="safe">已付款</div>
        </div>
      </template>
    </basicList>

    <previewComponents
      @close="closeView"
      :acceptedParameters="previewParams"
      @refresh="refresh"
    ></previewComponents>
  </div>
</template>

<script>
import axios from "axios";
import { getSession } from "@/utils/cookie";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { getRoles } from "@/utils";
import { itemClassGetList, commonQrGun } from "@/api/basicConfiguration";

import {
  StockItemAlarmGetList,
  StockItemAlarmAdd,
  TransactionGetList,
  StockItemAlarmDel,
  StockItemAlarmBatchDel,
  // exportExcel,
} from "@/api/product";
import {
  orderBuyGetOne,
  orderMoveDetail,
  getShopStocks,
} from "@/api/purchasing";
import { orderSellGetOne } from "@/api/sale";
import {
  getshoplist,
  userPermissionShopGetList,
  userGetlist,
  supplierGetList,
  customerGetList,
  userPermissionSupplierGetList,
} from "@/api/basicConfiguration";

// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "ProductTransaction",
  components: {
    Treeselect,
    previewComponents: () => import("@/components/previewComponents"),
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  data() {
    return {
      previewParams: {
        key: new Date().getTime(),
        visible: false,
        type: "saleOrder",
        viewObj: [],
        code: "",
      },
      compId: null,
      userId: null,
      roleId: null,
      shopIds: [], // 权限管理中允许用户使用的店铺，高级角色看所有店铺

      shop_id: null, // 用户选中门店
      isKeepDayActive: true,
      isKeepMonthActive: true,

      // 添加商品
      item_id: null,
      productOptions: [],
      itemMap: null,

      // 导入文件
      fileList: [], // 用于存储已选择的文件列表
      uploadAction: "", // 后端接收文件的接口

      qrcode: "",
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operationWidth: 100,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "商品分类",
            type: "treeselect",
            options: [],
            key: "class_id",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
          {
            label: "供应商",
            type: "select",
            options: [],
            key: "supplier_id",
            filterable: true, // 支持模糊搜索
            clearable: true,
            placeholder: "请选择供应商",
          },
          {
            label: "客户",
            type: "select",
            options: [],
            key: "customer_id",
            filterable: true, // 支持模糊搜索
            clearable: true,
            placeholder: "请选择客户",
          },
          // {
          //   label: "供应商/客户",
          //   type: "input",
          //   key: "supplier_name",
          // },
          // {
          //   label: "供应商/客户",
          //   type: "select",
          //   options: [],
          //   key: "supplier_id",
          // },
          {
            label: "单据类型",
            key: "item_way_type",
            type: "select",
            options: [
              {
                label: "采购",
                value: 1,
              },
              {
                label: "销售",
                value: 2,
              },
            ],
          },
        ],
        buttonList: [],
        data: [],
        column: [
          {
            label: "类型",
            prop: "order_type",
            slot: true,
            width: 80,
          },
          {
            label: "时间",
            prop: "create_time",
            width: 150,
          },
          {
            label: "编号",
            prop: "item_number",
            width: 150,
          },
          {
            label: "品名",
            prop: "name",
            width: 300,
          },
          {
            label: "客户",
            prop: "customer_name",
            slot: true,
            sortable: true,
            width: 180,
          },
          {
            label: "价格",
            prop: "price_distribution",
            sortable: true,
            isMoney: true,
            width: 180,
          },
          {
            label: "数量",
            prop: "num",
            width: 120,
          },
          {
            label: "小计",
            prop: "total_money",
            sortable: true,
            isMoney: true,
            width: 120,
          },
          {
            label: "门店",
            prop: "shopname",
            width: 120,
          },
          {
            label: "单号",
            prop: "form_sn",
            slot: true,
            width: 150,
          },
          {
            label: "付款状态",
            prop: "last_money",
            slot: true,
            isMoney: true,
            width: 120,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      addrules: {},

      dialogVisible: false,
      addform: {
        item_id: null,
        class_id: null,
        item_number: null,
        item_name: null,

        prod_date: null,
        keep_month: "",
        keep_day: "",
      },
      title: "",

      actionUrl: "",
      headers: {},
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.shopId = this.$store.getters.userInfo.shopId;

    if (this.shopId) {
      this.basicListconfig.searchParameters.shop_id = this.shopId;
    }

    this.getSuppliers();
    this.getCustomers();

    this.headers = {
      "x-token": getSession(),
    };

    this.uploadAction = "";
    switch (process.env.NODE_ENV) {
      // 线上同源
      case "prod":
        this.uploadAction = "http://47.100.124.64";
        break;
      // 开发同源
      case "dev":
        this.uploadAction = "https://erp.zuizhenshi.cn";
        break;
      // 开发跨域
      case "local":
        this.uploadAction = "https://erp.zuizhenshi.cn";
        break;
    }
    this.uploadAction = this.uploadAction + "/admin/item_alarm/importExcel";

    // 依据权限获取数据
    this.obtainPermissionDataSource(this.getPermissionId("商品-商品管理-查看"));

    this.getlist();
  },
  methods: {

    getSuppliers() {
      return supplierGetList({
        limit: 10000,
        status: 0,
        comp_id: this.compId,
      }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.forEach((item) => {
            if (item.key == "supplier_id") {
              item.options = res.data.map((item) => ({
                label: item.id + "-" + item.nick_name,
                value: item.id,
              }));
            }
          });
        } else {
          this.$message.error(res.data.msg || "获取供应商数据源失败！");
        }
      });
    },

    getCustomers() {
      return customerGetList({
        limit: 10000,
        status: 0,
        comp_id: this.compId,
      }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.forEach((item) => {
            if (item.key == "customer_id") {
              item.options = res.data.map((item) => ({
                label: item.name,
                value: item.id,
              }));
            }
          });
        } else {
          this.$message.error(res.data.msg || "获取客户数据源失败！");
        }
      });
    },

    purchaseOrder(row) {
      this.temporaryRowData = row;
      this.previewParams.code = row.form_sn;
      if (row.order_type == 2) {
        orderSellGetOne({ form_sn: row.form_sn }).then((res) => {
          if (res.code == 1) {
            let payData = res.$pay_list.map((item) => {
              item.pay_price = this.$money(item.pay_price);
              item.all_price = this.$money(item.all_price);
              item.last_price = this.$money(item.last_price);
              return item;
            });
            let item_way = res.item_way.map((item) => {
              if (item.pics) item.pics = item.pics.split(",");
              return item;
            });
            let data = res.$order_list.map((item) => {
              item.name =
                item.item_info.name +
                "(1*" +
                item.item_info.in_package_num +
                ")(" +
                item.item_info.item_number +
                ")";
              item.freeze_num = item.item_info.freeze_num;
              item.price_distribution = this.$money(item.price_distribution);
              item.item_stock_single = item.item_info.item_stock_single;
              item.item_stock_package = item.item_info.item_stock_package;
              item.total_money = this.$money(item.total_money);
              item.algorithm =
                item.price_distribution +
                "*" +
                "(" +
                item.single_num +
                "+" +
                item.package_num +
                "*" +
                item.item_info.in_package_num +
                ")" +
                "=" +
                item.total_money;
              item.total = item.num;
              //   Number(item.single_num) +
              //   Number(item.package_num) * Number(item.item_info.in_package_num);
              return item;
            });
            this.previewParams.viewObj = [
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "客户",
                    value: res.order_info.customer_name,
                  },
                  {
                    label: "销售门店",
                    value: res.order_info.shop_name,
                  },
                  {
                    label: "业务员",
                    value: res.order_info.customer_user_name,
                  },
                  {
                    label: "制单人",
                    value: res.order_info.user_name,
                  },
                ],
              },
              {
                title: "销售明细",
                type: "array",
                value: data,
                column: [
                  {
                    label: "商品名称",
                    prop: "name",
                    width: 500,
                  },
                  {
                    label: "销售单价",
                    prop: "price_distribution",
                  },

                  {
                    label: "销售总量",
                    prop: "total",
                    align: "center",
                    // children: [
                    //   {
                    //     label: "散",
                    //     prop: "single_num",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "箱",
                    //     prop: "package_num",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "总",
                    //     prop: "total",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    // ],
                  },
                  {
                    label: "小计金额",
                    prop: "total_money",
                    align: "center",
                    // children: [
                    //   {
                    //     label: "金额",
                    //     prop: "total_money",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "算法",
                    //     prop: "algorithm",
                    //     width: 200,
                    //     align: "center",
                    //   },
                    // ],
                  },
                ],
              },
              {
                title: "销售金额",
                type: "object",
                value: [
                  {
                    label: "商品金额",
                    value: this.$money(res.order_info.item_money),
                  },
                  {
                    label: "运费收入",
                    value: this.$money(res.order_info.trans_money),
                  },
                  {
                    label: "订单总金额",
                    value: this.$money(res.order_info.total_money),
                  },
                  {
                    label: "总数量",
                    value: res.order_info.num,
                  },
                  {
                    label: "运费支出",
                    value: this.$money(res.order_info.trans_money_self),
                  },
                  {
                    label: "余额抵扣",
                    value: this.$money(res.order_info.pre_money),
                  },
                  {
                    label: "净毛利",
                    value: this.$money(
                      Number(res.order_info.real_profit_money)
                    ),
                  },
                  {
                    label: "应收总金额",
                    value: this.$money(
                      Number(res.order_info.total_money) -
                        Number(res.order_info.pre_money)
                    ),
                  },
                ],
              },
              {
                title: "收款信息",
                type: "array",
                value: payData,
                column: [
                  {
                    label: "收款账户",
                    prop: "account_name",
                  },
                  {
                    label: "收款",
                    prop: "all_price",
                  },
                  {
                    label: "结款",
                    prop: "pay_price",
                  },
                  {
                    label: "余款",
                    prop: "last_price",
                  },
                  {
                    label: "时间",
                    prop: "create_time",
                  },
                  {
                    label: "类型",
                    prop: "pay_type",
                  },
                  {
                    label: "操作",
                    prop: "operation",
                  },
                ],
              },
              {
                title: "收款信息",
                type: "object",
                value: [
                  {
                    label: "已收金额",
                    value: this.$money(res.order_info.payed_money),
                  },
                  {
                    label: "未收金额",
                    value: this.$money(res.order_info.last_money),
                  },
                ],
              },
              {
                title: "订单备注",
                type: "object",
                value: [
                  {
                    label: "公司名称",
                    value: res.order_info.comp_remark,
                  },
                  {
                    label: "其它备注",
                    value: res.order_info.remark,
                  },
                ],
              },
              {
                title: "溯源信息",
                type: "array",
                value: item_way,
                column: [
                  {
                    label: "ID",
                    prop: "id",
                    width: 80,
                  },
                  {
                    label: "溯源码",
                    prop: "code_value",
                  },
                  // {
                  //   label: "品名",
                  //   prop: "item_name",
                  // },
                  // {
                  //   label: "会员号",
                  //   prop: "customer_id",
                  // },
                  {
                    label: "操作人",
                    prop: "user_name",
                    width: 100,
                  },
                  {
                    label: "溯源照片",
                    prop: "pics",
                    width: 200,
                  },
                  {
                    label: "更新时间",
                    prop: "update_time",
                    width: 100,
                  },
                ],
              },
            ];

            this.previewParams.key = new Date().getTime();
            this.previewParams.visible = true;
            this.previewParams.type = "sale";
          } else {
            this.$message.error("获取详情失败");
          }
        });
      } else {
        orderBuyGetOne({ form_sn: row.form_sn }).then((res) => {
          if (res.code == 1) {
            let payData = res.$pay_list.map((item) => {
              item.pay_price = this.$money(item.pay_price);
              item.all_price = this.$money(item.all_price);
              item.last_price = this.$money(item.last_price);
              return item;
            });
            let item_way = res.item_way.map((item) => {
              if (item.pics) item.pics = item.pics.split(",");
              return item;
            });
            let data = res.$order_list.map((item) => {
              item.name =
                item.item_info.name +
                "(1*" +
                item.item_info.in_package_num +
                ")";
              item.price_distribution = this.$money(item.price_distribution);
              item.need_item_stock_single = item.single_num;
              item.need_item_stock_package = item.package_num;
              item.total_money = this.$money(item.total_money);
              item.price_oneBox = (
                Number(item.price_distribution) * Number(item.in_package_num)
              ).toFixed(2);
              item.need_item_stock_total = (
                Number(item.need_item_stock_single) +
                Number(item.need_item_stock_package) *
                  Number(item.in_package_num)
              ).toFixed(0);
              item.algorithm =
                item.price_distribution +
                "*" +
                "(" +
                item.need_item_stock_single +
                "+" +
                item.need_item_stock_package +
                "*" +
                item.in_package_num +
                ") = " +
                item.total_money;
              return item;
            });
            this.previewParams.viewObj = [
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "供应商",
                    value: res.order_info.supplier_name,
                  },
                  {
                    label: "采购门店",
                    value: res.order_info.shop_name,
                  },
                  {
                    label: "采购人",
                    value: res.order_info.customer_name,
                  },
                  {
                    label: "制单人",
                    value: res.order_info.user_name,
                  },
                  {
                    label: "备注",
                    value: res.order_info.remark,
                  },
                ],
              },
              {
                title: "采购明细",
                type: "array",
                value: data,
                column: [
                  {
                    label: "商品名称",
                    prop: "name",
                  },
                  {
                    label: "单价",
                    prop: "price_distribution",
                  },
                  {
                    label: "采购数量",
                    prop: "num",
                    align: "center",
                  },
                  {
                    label: "小计",
                    prop: "total_money",
                    width: 200,
                  },
                ],
              },
              {
                title: "采购金额",
                type: "object",
                value: [
                  {
                    label: "商品金额",
                    value: this.$money(res.order_info.item_money),
                  },
                  {
                    label: "运费金额",
                    value: this.$money(res.order_info.trans_money),
                  },
                  {
                    label: "订单总金额",
                    value: this.$money(res.order_info.total_money),
                  },
                  {
                    label: "余额抵扣",
                    value: this.$money(res.order_info.pre_money),
                  },
                  {
                    label: "应付总金额",
                    value: this.$money(
                      Number(res.order_info.total_money) -
                        Number(res.order_info.pre_money)
                    ),
                  },
                ],
              },
              {
                title: "付款信息",
                type: "array",
                value: payData,
                column: [
                  {
                    label: "付款账户",
                    prop: "account_name",
                  },
                  {
                    label: "付款",
                    prop: "all_price",
                  },
                  {
                    label: "结款",
                    prop: "pay_price",
                  },
                  {
                    label: "余款",
                    prop: "last_price",
                  },
                  {
                    label: "时间",
                    prop: "create_time",
                  },
                  {
                    label: "类型",
                    prop: "pay_type",
                  },
                  {
                    label: "操作",
                    prop: "operation",
                  },
                ],
              },
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "已付金额",
                    value: this.$money(res.order_info.payed_money),
                  },
                  {
                    label: "未付金额",
                    value: this.$money(res.order_info.last_money),
                  },
                ],
              },
              {
                title: "溯源信息",
                type: "array",
                value: item_way,
                column: [
                  {
                    label: "ID",
                    prop: "id",
                    width: 80,
                  },
                  {
                    label: "溯源码",
                    prop: "code_value",
                  },
                  {
                    label: "操作人",
                    prop: "user_name",
                    width: 100,
                  },
                  {
                    label: "溯源照片",
                    prop: "pics",
                    width: 200,
                  },
                  {
                    label: "更新时间",
                    prop: "update_time",
                    width: 100,
                  },
                ],
              },
            ];

            this.previewParams.key = new Date().getTime();
            this.previewParams.visible = true;
          } else {
            this.$message.error("获取详情失败");
          }
        });
      }
    },
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    handleInput(field) {
      if (field === "keep_month" && this.addform.keep_month !== "") {
        this.addform.keep_day = ""; // 当输入保质月时，清空保质天
      } else if (field === "keep_day" && this.addform.keep_day !== "") {
        this.addform.keep_month = ""; // 当输入保质天时，清空保质月
      }
    },
    // 获取数据源
    obtainPermissionDataSource(permissionId) {
      // 获取商品分类
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });

      // 超级用户获取全部店铺
      if (this.roleId != 4) {
        getshoplist({ limit: 10000, status: 0, comp_id: this.compId }).then(
          (res) => {
            if (res.code == 1) {
              this.basicListconfig.search.map((item) => {
                if (item.key == "shop_id") {
                  item.options = res.data.map((item) => {
                    return {
                      label: item.name,
                      value: item.id,
                    };
                  });
                }
                return item;
              });

              // this.storeOptions = res.data.map((item) => {
              //   return {
              //     label: item.name,
              //     value: Number(item.id),
              //   };
              // });
            } else {
              this.$message.error(res.data.msg);
            }
          }
        );

        // 普通用户获取赋权店面
      } else {

        userPermissionShopGetList({
          comp_id: this.compId,
          user_id: this.userId,
          permission_id: this.getPermissionId("商品-商品管理-查看"),
        }).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });

            // this.storeOptions = res.data.map((item) => {
            //   return {
            //     label: item.name,
            //     value: Number(item.id),
            //   };
            // });
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }

      // itemClassGetList().then((res) => {
      //   if (res.code == 1) {
      //     this.classOptions = this.$findChildren(0, res.data);
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // });
    },

    // 关闭查看
    closeView() {
      // this.previewParams.key = new Date().getTime();
      this.previewParams.visible = false;
    },
    refresh() {
      this.preview(this.temporaryRowData, "previewParams");
    },
    preview(row, name) {
      this.temporaryRowData = row;
      this.previewParams.code = row.form_sn;
      if (row.order_type == 2) {
        orderSellGetOne({ form_sn: row.form_sn }).then((res) => {
          if (res.code == 1) {
            let payData = res.$pay_list.map((item) => {
              item.pay_price = this.$money(item.pay_price);
              item.all_price = this.$money(item.all_price);
              item.last_price = this.$money(item.last_price);
              return item;
            });
            let item_way = res.item_way.map((item) => {
              if (item.pics) item.pics = item.pics.split(",");
              return item;
            });
            let data = res.$order_list.map((item) => {
              item.name =
                item.item_info.name +
                "(1*" +
                item.item_info.in_package_num +
                ")(" +
                item.item_info.item_number +
                ")";
              item.freeze_num = item.item_info.freeze_num;
              item.price_distribution = this.$money(item.price_distribution);
              item.item_stock_single = item.item_info.item_stock_single;
              item.item_stock_package = item.item_info.item_stock_package;
              item.total_money = this.$money(item.total_money);
              item.algorithm =
                item.price_distribution +
                "*" +
                "(" +
                item.single_num +
                "+" +
                item.package_num +
                "*" +
                item.item_info.in_package_num +
                ")" +
                "=" +
                item.total_money;
              item.total =
                Number(item.single_num) +
                Number(item.package_num) *
                  Number(item.item_info.in_package_num);
              return item;
            });
            this.previewParams.viewObj = [
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "客户",
                    value: res.order_info.customer_name,
                  },
                  {
                    label: "销售门店",
                    value: res.order_info.shop_name,
                  },
                  {
                    label: "业务员",
                    value: res.order_info.customer_user_name,
                  },
                  {
                    label: "制单人",
                    value: res.order_info.user_name,
                  },
                ],
              },
              {
                title: "销售明细",
                type: "array",
                value: data,
                column: [
                  {
                    label: "商品名称",
                    prop: "name",
                    width: 500,
                  },
                  {
                    label: "销售单价",
                    prop: "price_distribution",
                  },

                  {
                    label: "销售总量",
                    prop: "total",
                    align: "center",
                    // children: [
                    //   {
                    //     label: "散",
                    //     prop: "single_num",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "箱",
                    //     prop: "package_num",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "总",
                    //     prop: "total",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    // ],
                  },
                  {
                    label: "小计金额",
                    prop: "total_money",
                    align: "center",
                    // children: [
                    //   {
                    //     label: "金额",
                    //     prop: "total_money",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "算法",
                    //     prop: "algorithm",
                    //     width: 200,
                    //     align: "center",
                    //   },
                    // ],
                  },
                ],
              },
              {
                title: "销售金额",
                type: "object",
                value: [
                  {
                    label: "商品金额",
                    value: this.$money(res.order_info.item_money),
                  },
                  {
                    label: "运费收入",
                    value: this.$money(res.order_info.trans_money),
                  },
                  {
                    label: "订单总金额",
                    value: this.$money(res.order_info.total_money),
                  },
                  {
                    label: "总数量",
                    value: res.order_info.num,
                  },
                  {
                    label: "运费支出",
                    value: this.$money(res.order_info.trans_money_self),
                  },
                  {
                    label: "余额抵扣",
                    value: this.$money(res.order_info.pre_money),
                  },
                  {
                    label: "净毛利",
                    value: this.$money(
                      Number(res.order_info.real_profit_money)
                    ),
                  },
                  {
                    label: "应收总金额",
                    value: this.$money(
                      Number(res.order_info.total_money) -
                        Number(res.order_info.pre_money)
                    ),
                  },
                ],
              },
              {
                title: "收款信息",
                type: "array",
                value: payData,
                column: [
                  {
                    label: "收款账户",
                    prop: "account_name",
                  },
                  {
                    label: "收款",
                    prop: "all_price",
                  },
                  {
                    label: "结款",
                    prop: "pay_price",
                  },
                  {
                    label: "余款",
                    prop: "last_price",
                  },
                  {
                    label: "时间",
                    prop: "create_time",
                  },
                  {
                    label: "类型",
                    prop: "pay_type",
                  },
                  {
                    label: "操作",
                    prop: "operation",
                  },
                ],
              },
              {
                title: "收款信息",
                type: "object",
                value: [
                  {
                    label: "已收金额",
                    value: this.$money(res.order_info.payed_money),
                  },
                  {
                    label: "未收金额",
                    value: this.$money(res.order_info.last_money),
                  },
                ],
              },
              {
                title: "订单备注",
                type: "object",
                value: [
                  {
                    label: "公司名称",
                    value: res.order_info.comp_remark,
                  },
                  {
                    label: "其它备注",
                    value: res.order_info.remark,
                  },
                ],
              },
              {
                title: "溯源信息",
                type: "array",
                value: item_way,
                column: [
                  {
                    label: "ID",
                    prop: "id",
                    width: 80,
                  },
                  {
                    label: "溯源码",
                    prop: "code_value",
                  },
                  // {
                  //   label: "品名",
                  //   prop: "item_name",
                  // },
                  // {
                  //   label: "会员号",
                  //   prop: "customer_id",
                  // },
                  {
                    label: "操作人",
                    prop: "user_name",
                    width: 100,
                  },
                  {
                    label: "溯源照片",
                    prop: "pics",
                    width: 200,
                  },
                  {
                    label: "更新时间",
                    prop: "update_time",
                    width: 100,
                  },
                ],
              },
            ];

            this.previewParams.key = new Date().getTime();
            this.previewParams.visible = true;
            this.previewParams.type = "sale";
          } else {
            this.$message.error("获取详情失败");
          }
        });
      } else {
        orderBuyGetOne({ form_sn: row.form_sn }).then((res) => {
          if (res.code == 1) {
            let payData = res.$pay_list.map((item) => {
              item.pay_price = this.$money(item.pay_price);
              item.all_price = this.$money(item.all_price);
              item.last_price = this.$money(item.last_price);
              return item;
            });
            let item_way = res.item_way.map((item) => {
              if (item.pics) item.pics = item.pics.split(",");
              return item;
            });
            let data = res.$order_list.map((item) => {
              item.name = item.item_info.name;
              item.price_distribution = this.$money(item.price_distribution);
              item.need_item_stock_single = item.single_num;
              item.need_item_stock_package = item.package_num;
              item.total_money = (
                Number(item.price_distribution) *
                (Number(item.need_item_stock_single) +
                  Number(item.need_item_stock_package) *
                    Number(item.in_package_num))
              ).toFixed(2);
              item.price_oneBox = (
                Number(item.price_distribution) * Number(item.in_package_num)
              ).toFixed(2);
              item.need_item_stock_total = (
                Number(item.need_item_stock_single) +
                Number(item.need_item_stock_package) *
                  Number(item.in_package_num)
              ).toFixed(0);
              item.algorithm =
                item.price_distribution +
                "*" +
                "(" +
                item.need_item_stock_single +
                "+" +
                item.need_item_stock_package +
                "*" +
                item.in_package_num +
                ") = " +
                item.total_money;
              return item;
            });
            this.previewParams.viewObj = [
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "供应商",
                    value: res.order_info.supplier_name,
                  },
                  {
                    label: "采购门店",
                    value: res.order_info.shop_name,
                  },
                  {
                    label: "采购人",
                    value: res.order_info.customer_name,
                  },
                  {
                    label: "制单人",
                    value: res.order_info.user_name,
                  },
                  {
                    label: "备注",
                    value: res.order_info.remark,
                  },
                ],
              },
              {
                title: "采购明细",
                type: "array",
                value: data,
                column: [
                  {
                    label: "商品名称",
                    prop: "name",
                  },
                  {
                    label: "单价",
                    prop: "price_distribution",
                  },
                  {
                    label: "采购数量",
                    prop: "need_item_stock_total",
                    align: "center",
                    // children: [
                    //   {
                    //     label: "散",
                    //     prop: "need_item_stock_single",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "箱",
                    //     prop: "need_item_stock_package",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "总",
                    //     prop: "need_item_stock_total",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    // ],
                  },
                  {
                    label: "小计",
                    prop: "total_money",
                    width: 200,
                  },
                ],
              },
              {
                title: "采购金额",
                type: "object",
                value: [
                  {
                    label: "商品金额",
                    value: this.$money(res.order_info.item_money),
                  },
                  {
                    label: "运费金额",
                    value: this.$money(res.order_info.trans_money),
                  },
                  {
                    label: "订单总金额",
                    value: this.$money(res.order_info.total_money),
                  },
                  {
                    label: "余额抵扣",
                    value: this.$money(res.order_info.pre_money),
                  },
                  {
                    label: "应付总金额",
                    value: this.$money(
                      Number(res.order_info.total_money) -
                        Number(res.order_info.pre_money)
                    ),
                  },
                ],
              },
              {
                title: "付款信息",
                type: "array",
                value: payData,
                column: [
                  {
                    label: "付款账户",
                    prop: "account_name",
                  },
                  {
                    label: "付款",
                    prop: "all_price",
                  },
                  {
                    label: "结款",
                    prop: "pay_price",
                  },
                  {
                    label: "余款",
                    prop: "last_price",
                  },
                  {
                    label: "时间",
                    prop: "create_time",
                  },
                  {
                    label: "类型",
                    prop: "pay_type",
                  },
                  {
                    label: "操作",
                    prop: "operation",
                  },
                ],
              },
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "已付金额",
                    value: this.$money(res.order_info.payed_money),
                  },
                  {
                    label: "未付金额",
                    value: this.$money(res.order_info.last_money),
                  },
                ],
              },
              {
                title: "溯源信息",
                type: "array",
                value: item_way,
                column: [
                  {
                    label: "ID",
                    prop: "id",
                    width: 80,
                  },
                  {
                    label: "溯源码",
                    prop: "code_value",
                  },
                  // {
                  //   label: "品名",
                  //   prop: "item_name",
                  // },
                  // {
                  //   label: "会员号",
                  //   prop: "supplier_id",
                  // },
                  {
                    label: "操作人",
                    prop: "user_name",
                    width: 100,
                  },
                  {
                    label: "溯源照片",
                    prop: "pics",
                    width: 200,
                  },
                  {
                    label: "更新时间",
                    prop: "update_time",
                    width: 100,
                  },
                ],
              },
            ];

            this.previewParams.key = new Date().getTime();
            this.previewParams.visible = true;
          } else {
            this.$message.error("获取详情失败");
          }
        });
      }
    },
    // 导出文件
    exportExcel() {
      let headers = {
        "x-token": getSession(),
      };
      let downloadUrl =
        (process.env.NODE_ENV === "production"
          ? "https://erp.zuizhenshi.cn"
          : "https://erp.zuizhenshi.cn") + "/admin/item_alarm/exportExcel";
      if (!this.basicListconfig.searchParameters.shop_id) {
        this.$message.error("请先选中店面");
        return;
      }
      let url =
        downloadUrl +
        "?comp_id=" +
        this.compId +
        "&shop_id=" +
        this.basicListconfig.searchParameters.shop_id;

      axios({
        method: "GET",
        url: url,
        responseType: "blob", // 重要，设置响应类型为blob
        withCredentials: true, // 如果需要携带 cookie
        headers: {
          "x-token": getSession(), // 添加自定义请求头
        },
      })
        .then((response) => {
          // 创建一个新的 Blob 对象，使用响应数据
          const blob = new Blob([response.data]);
          // 为 Blob 生成一个链接
          const downloadUrl = window.URL.createObjectURL(blob);
          // 创建一个临时的 <a> 标签用于下载
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "醉真实-商品有效期-导出数据.xlsx"); // 设置下载文件名
          document.body.appendChild(link);
          link.click(); // 模拟点击进行下载
          document.body.removeChild(link); // 下载完成后移除元素
          window.URL.revokeObjectURL(downloadUrl); // 释放掉blob对象使用的内存
        })
        .catch((error) => {
          console.error("下载文件失败:", error);
        });
    },

    // dynamic(data) {
    //   if (data == "batchDeletion") {
    //     StockItemAlarmBatchDel({
    //       comp_id: this.compId,
    //       id: this.selectIds.join(","),
    //     }).then((res) => {
    //       if (res.code == 1) {
    //         this.basicListconfig.loading = false;
    //         this.getlist();
    //       } else if (res.code == 0) {
    //         this.basicListconfig.loading = false;
    //         this.$message.error(res.msg);
    //       }
    //     });
    //   }
    // },

    cancel() {
      this.reset();
      this.dialogVisible = false;
    },
    reset() {
      this.addform = {
        item_id: null,
        item_name: null,
        item_number: null,
        class_id: null,

        prod_date: null,
        keep_month: null,
        keep_day: null,
      };
      this.qrcode = "";
    },
    add() {
      this.addform.comp_id = this.compId;
      this.addform.shop_id = this.basicListconfig.searchParameters.shop_id;
      if (!this.addform.prod_date) {
        this.$message.error("生产日期不能为空");
        return;
      }
      StockItemAlarmAdd(this.addform).then((res) => {
        // console.log(
        //   "%c [ res ]-301",
        //   "font-size:13px; background:pink; color:#bf2c9f;",
        //   res
        // );
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.dialogVisible = false;
          this.getlist();
        } else if (res.code == 0) {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },

    // 表格选择数据事件
    handleSelectionChange(data) {},
    // 新增事件
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.basicListconfig.searchParameters.begin_time;
              delete this.basicListconfig.searchParameters.end_time;
            } else {
              this.basicListconfig.searchParameters.begin_time = data[key][0];
              this.basicListconfig.searchParameters.end_time = data[key][1];
            }
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;

        // 默认查本店
        // if (!this.basicListconfig.searchParameters.shop_id) {
        //   this.$message.error("请先选中门店！");
        //   return;
        // }

        this.getlist();
      }
    },

    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;

      // 有用户门店权限的，查看只能看指定门店记录
      // 用户选中店铺时，按所选店铺查看; 未选时，按用户权限所有店面查询
      if (!this.basicListconfig.searchParameters["shop_id"]) {
        if (this.shopIds.length != 0) {
          this.basicListconfig.searchParameters["shop_id"] =
            this.shopIds.join(", ");
        }
      }
      this.basicListconfig.searchParameters["comp_id"] = this.compId;
      TransactionGetList(this.basicListconfig.searchParameters).then((res) => {
        console.log(
          "%c [ res ]-301",
          "font-size:13px; background:pink; color:#bf2c9f;",
          res
        );
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else if (res.code == 0) {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style>
.warn,
.dangerous,
.safe {
  margin-right: 5px; /* 右边距 */
}

/* 小于或等于10天时的警告样式 */
.warn {
  color: red; /* 红色文字 */
}

/* 负数时的警告样式 */
.dangerous {
  color: red; /* 红色文字 */
  font-weight: bold; /* 字体加粗 */
}

.safe {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/views/ProductTransaction/index.vue